module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-brass-brushed-4042-scale.3849a654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-brass-brushed-4042-scale.jpg
// module id = 1111
// module chunks = 37